(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-jet-tags"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__stekuJetTagGift) return;
    var nativeFetch = window.fetch.bind(window);
    var EVENTS = ['cart:updated', 'ajaxProduct:added', 'drawerOpen', 'cart:build'];

    function root() { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }
    function isGift(item) { return !!(item && item.properties && item.properties._free_gift); }
    function post(path, body) {
      return nativeFetch(root() + path, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      });
    }
    function mapData() {
      var el = document.querySelector('script[data-jt-map]');
      if (!el) return { on: false, start: '', gifts: [] };
      try { return JSON.parse(el.textContent) || { on: false, start: '', gifts: [] }; } catch (e) { return { on: false, start: '', gifts: [] }; }
    }
    // Switch + schedule (Theme settings > Free jet tag gift). The start time is checked
    // against the visitor's real clock, because Liquid 'now' can be cached by the storefront.
    // Switch off, or a start time that can't be read, means no gifts at all.
    function active() {
      var d = mapData();
      if (!d.on) return false;
      if (!d.start) return true;
      var t = Date.parse(d.start);
      return !isNaN(t) && Date.now() >= t;
    }
    function giftMap() {
      if (!active()) return [];
      var el = document.querySelector('script[data-jt-map]');
      if (!el) return [];
      return mapData().gifts || [];
    }

    // ---------- Adding: rewrite /cart/add requests to include the gift ----------

    function isAddRequest(input, init) {
      var method = ((init && init.method) || (input && input.method) || 'GET').toUpperCase();
      if (method !== 'POST' || !init || init.body == null) return false;
      var url = typeof input === 'string' ? input : (input && input.url) || String(input || '');
      try { return /\/cart\/add(\.js)?$/.test(new URL(url, location.href).pathname); } catch (e) { return false; }
    }

    // Normalise any add body (JSON string, FormData, URLSearchParams) to { items, extra, single }.
    function parseBody(body) {
      if (typeof body === 'string') {
        var j;
        try { j = JSON.parse(body); } catch (e) { return null; }
        if (!j || typeof j !== 'object') return null;
        var extra = {};
        Object.keys(j).forEach(function (k) {
          if (['items', 'id', 'quantity', 'properties', 'selling_plan'].indexOf(k) === -1) extra[k] = j[k];
        });
        if (Array.isArray(j.items)) return { items: j.items, extra: extra, single: false };
        if (j.id == null) return null;
        var it = { id: j.id, quantity: j.quantity || 1 };
        if (j.properties) it.properties = j.properties;
        if (j.selling_plan) it.selling_plan = j.selling_plan;
        return { items: [it], extra: extra, single: true };
      }
      if ((typeof FormData !== 'undefined' && body instanceof FormData) || (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams)) {
        var single = { properties: {} };
        var multi = {};
        var extraF = {};
        var bad = false;
        body.forEach(function (value, name) {
          if (typeof value !== 'string') { bad = true; return; } // file upload: leave the request alone
          var m;
          if (name === 'id') single.id = value;
          else if (name === 'quantity') single.quantity = parseInt(value, 10) || 1;
          else if (name === 'selling_plan') { if (value) single.selling_plan = value; }
          else if ((m = name.match(/^properties\[(.+)\]$/))) single.properties[m[1]] = value;
          else if ((m = name.match(/^items\[(\d+)\]\[(id|quantity|selling_plan)\]$/))) { multi[m[1]] = multi[m[1]] || {}; multi[m[1]][m[2]] = value; }
          else if ((m = name.match(/^items\[(\d+)\]\[properties\]\[(.+)\]$/))) { multi[m[1]] = multi[m[1]] || {}; multi[m[1]].properties = multi[m[1]].properties || {}; multi[m[1]].properties[m[2]] = value; }
          else if (name === 'sections' || name === 'sections_url') extraF[name] = value;
        });
        if (bad) return null;
        var keys = Object.keys(multi);
        if (keys.length) {
          return { items: keys.sort(function (a, b) { return a - b; }).map(function (k) { return multi[k]; }), extra: extraF, single: false };
        }
        if (!single.id) return null;
        var one = { id: single.id, quantity: single.quantity || 1 };
        if (Object.keys(single.properties).length) one.properties = single.properties;
        if (single.selling_plan) one.selling_plan = single.selling_plan;
        return { items: [one], extra: extraF, single: true };
      }
      return null;
    }

    // One gift per series: every distinct gift that the added items qualify for (Chainsaw pieces get the
    // Chainsaw tag, Curses pieces the Curses tag, a request with both gets both).
    function giftsFor(items) {
      var map = giftMap();
      var giftIds = map.map(function (g) { return String(g.gift); });
      for (var i = 0; i < items.length; i++) {
        var vid = String(items[i].id);
        if (giftIds.indexOf(vid) !== -1) return []; // a gift is being added explicitly
      }
      var out = [];
      for (var k = 0; k < items.length; k++) {
        var v = parseInt(items[k].id, 10);
        for (var g = 0; g < map.length; g++) {
          if (map[g].ok && map[g].variants.indexOf(v) !== -1 && out.indexOf(map[g].gift) === -1) out.push(map[g].gift);
        }
      }
      return out;
    }

    function withGift(input, init) {
      var parsed = parseBody(init.body);
      if (!parsed) return null;
      var gifts = giftsFor(parsed.items);
      if (!gifts.length) return null;
      return nativeFetch(root() + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var have = {};
          (cart.items || []).forEach(function (i) { if (isGift(i)) have[String(i.variant_id)] = true; });
          var need = gifts.filter(function (g) { return !have[String(g)]; }); // one free tag per series, never a second of the same
          if (!need.length) return nativeFetch(input, init);
          var headers = new Headers(init.headers || {});
          headers.set('Content-Type', 'application/json');
          headers.set('Accept', 'application/json');
          var body = Object.assign({}, parsed.extra, {
            items: need.map(function (g) { return { id: g, quantity: 1, properties: { _free_gift: 'true' } }; }).concat(parsed.items)
          });
          var init2 = Object.assign({}, init, { headers: headers, body: JSON.stringify(body) });
          return nativeFetch(input, init2).then(function (res) {
            if (!res.ok) return nativeFetch(input, init); // gift sold out or similar: add the product alone
            return res.json().then(function (json) {
              var items = (json.items || []).filter(function (i) { return !isGift(i); });
              var shaped;
              if (parsed.single) {
                shaped = items[0] || json;
                if (json.sections) shaped.sections = json.sections;
              } else {
                shaped = Object.assign({}, json, { items: items });
              }
              return new Response(JSON.stringify(shaped), { status: res.status, headers: { 'Content-Type': 'application/json' } });
            });
          });
        })
        .catch(function () { return nativeFetch(input, init); });
    }

    window.fetch = function (input, init) {
      try {
        if (isAddRequest(input, init)) {
          var p = withGift(input, init);
          if (p) return p;
        }
      } catch (e) {}
      return nativeFetch(input, init);
    };

    // ---------- Removing: automatic clean up after every cart change ----------

    var manager = {
      busy: false,
      pending: false,
      attempts: {},
      timer: null,

      schedule: function () {
        var self = this;
        clearTimeout(this.timer);
        this.timer = setTimeout(function () { self.run(); }, 150);
      },

      run: function () {
        var self = this;
        if (this.busy) { this.pending = true; return; }
        this.busy = true;
        Promise.all([
          nativeFetch(root() + '?section_id=cart-jet-tags', { credentials: 'same-origin' }).then(function (r) { return r.text(); }),
          nativeFetch(root() + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); })
        ])
          .then(function (res) {
            var holder = document.createElement('div');
            holder.innerHTML = res[0];
            var node = holder.querySelector('[data-jt-state]');
            if (!node) return false;
            return self.reconcile(JSON.parse(node.textContent), res[1]);
          })
          .catch(function () { return false; })
          .then(function (changed) {
            self.busy = false;
            if (changed) {
              document.dispatchEvent(new CustomEvent('cart:build'));
            } else if (self.pending) {
              self.pending = false;
              self.schedule();
            }
          });
      },

      reconcile: function (state, cart) {
        var valid = {};
        if (active()) (state.valid || []).forEach(function (id) { valid[id] = true; }); // before the start, any gift line is removed
        var gifts = (cart.items || []).filter(isGift);
        var seen = {};
        var updates = {};
        var needUpdate = false;
        gifts.forEach(function (g) {
          // keep one line for every gift whose series is still in the cart; drop the rest and any duplicate
          if (!valid[g.variant_id] || seen[g.variant_id]) { updates[g.key] = 0; needUpdate = true; return; }
          seen[g.variant_id] = true;
          if (g.quantity !== 1) { updates[g.key] = 1; needUpdate = true; }
        });
        if (!needUpdate) return Promise.resolve(false);
        // Loop guard: the same change is tried at most twice in 20 seconds.
        var sig = JSON.stringify(updates);
        var now = Date.now();
        var a = this.attempts[sig];
        var fresh = a && now - a.t < 20000;
        if (fresh && a.n >= 2) return Promise.resolve(false);
        this.attempts[sig] = { t: fresh ? a.t : now, n: fresh ? a.n + 1 : 1 };
        return post('cart/update.js', { updates: updates }).then(function (r) { return r.ok; }).catch(function () { return false; });
      }
    };
    window.__stekuJetTagGift = manager;

    // ---------- Buy it now: the accelerated button skips the cart, so the gift would never be added ----------
    // On a product that has a live gift, the click is taken over: the product is added through the normal
    // /cart/add request (the fetch wrapper above adds the gift to it) and the shopper goes straight to checkout,
    // where both lines show, the gift at R0. On every other product the button behaves exactly as before.
    document.addEventListener('click', function (e) {
      var host = e.target && e.target.closest && e.target.closest('shopify-accelerated-checkout, .shopify-payment-button');
      if (!host) return;
      var form = host.closest('form');
      if (!form) return;
      var idEl = form.querySelector('[name="id"]');
      var variantId = idEl ? parseInt(idEl.value, 10) : NaN;
      if (isNaN(variantId)) return;
      var hasGift = giftMap().some(function (g) { return g.ok && (g.variants || []).indexOf(variantId) > -1; });
      if (!hasGift) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      if (host.__jtBusy) return;
      host.__jtBusy = true;
      var qtyEl = form.querySelector('[name="quantity"]');
      var qty = Math.max(1, parseInt(qtyEl && qtyEl.value, 10) || 1);
      // window.fetch is the wrapped one here, so the gift rides along in this request.
      window.fetch(root() + 'cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: qty }] })
      }).then(function (r) {
        if (!r.ok) throw new Error('add failed');
        window.location.href = root() + 'checkout';
      }).catch(function () {
        host.__jtBusy = false;
        window.location.href = root() + 'cart';
      });
    }, true);

    class CartJetTags extends HTMLElement {
      connectedCallback() {
        if (manager.started) return;
        manager.started = true;
        EVENTS.forEach(function (ev) { document.addEventListener(ev, function () { manager.schedule(); }); });
        manager.schedule();
      }
    }
    if (!customElements.get('cart-jet-tags')) customElements.define('cart-jet-tags', CartJetTags);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-upsell"] && !Shopify.designMode) return;
  try {
    (function () {
    class CartUpsell extends HTMLElement {
      connectedCallback() {
        if (this._init) return;
        this._init = true;
        this.base = this.dataset.urlBase;
        this.content = this.querySelector('[data-upsell-content]');
        this._seed = null;
        this._loaded = false;
        this._refresh = this.refresh.bind(this);
        ['cart:updated', 'ajaxProduct:added', 'drawerOpen', 'cart:build'].forEach(function (ev) {
          document.addEventListener(ev, this._refresh);
        }, this);
        // Add to cart is delegated on the persistent host element, so it keeps
        // working no matter how many times the cards are re-injected.
        this.addEventListener('click', this.onClick.bind(this));
        this.enableDragScroll();
        this.refresh();
      }

      // Desktop: click-and-drag the strip to scroll. A real drag is suppressed
      // from firing Add to cart / opening the product. Touch keeps native swipe.
      enableDragScroll() {
        var c = this.content;
        var down = false, moved = false, startX = 0, startLeft = 0;

        c.addEventListener('pointerdown', function (e) {
          if (e.pointerType === 'touch') return; // native swipe handles touch
          down = true;
          moved = false;
          startX = e.clientX;
          startLeft = c.scrollLeft;
          c.classList.add('is-grabbing');
        });
        c.addEventListener('pointermove', function (e) {
          if (!down) return;
          var dx = e.clientX - startX;
          if (Math.abs(dx) > 8) moved = true;
          c.scrollLeft = startLeft - dx;
        });
        function end() {
          if (!down) return;
          down = false;
          c.classList.remove('is-grabbing');
        }
        c.addEventListener('pointerup', end);
        c.addEventListener('pointerleave', end);
        c.addEventListener('pointercancel', end);
        // Block the click that follows a drag so it doesn't add/navigate.
        c.addEventListener('click', function (e) {
          if (moved) { e.preventDefault(); e.stopPropagation(); }
        }, true);
        // Stop the browser's native image/link ghost-drag.
        c.addEventListener('dragstart', function (e) { e.preventDefault(); });

        // Also let a vertical mouse wheel scroll it horizontally.
        c.addEventListener('wheel', function (e) {
          if (!e.deltaY || c.scrollWidth <= c.clientWidth) return;
          c.scrollLeft += e.deltaY;
          e.preventDefault();
        }, { passive: false });
      }

      refresh() {
        var self = this;
        clearTimeout(this._t);
        this._t = setTimeout(function () {
          fetch(window.Shopify.routes.root + 'cart.js', { headers: { 'Accept': 'application/json' } })
            .then(function (r) { return r.json(); })
            .then(function (cart) { self.update(cart); })
            .catch(function () {});
        }, 80);
      }

      update(cart) {
        var items = (cart && cart.items) || [];
        if (!items.length) {
          this.hidden = true;
          this._seed = null;
          this._loaded = false;
          return;
        }
        var seed = items[items.length - 1].product_id;
        if (seed === this._seed && this._loaded) {
          this.filterInCart(items);
          return;
        }
        this._seed = seed;

        var url = this.base + '?section_id=cart-recommendations&product_id=' + seed + '&intent=related&limit=10';
        var self = this;
        fetch(url)
          .then(function (r) { return r.text(); })
          .then(function (text) {
            var holder = document.createElement('div');
            holder.innerHTML = text;
            var recs = holder.querySelector('.product-recommendations');
            if (!recs || !recs.children.length) {
              self.hidden = true;
              self._loaded = false;
              return;
            }
            self.content.innerHTML = recs.innerHTML;
            self._loaded = true;
            self.filterInCart(items);
          })
          .catch(function () { self.hidden = true; });
      }

      filterInCart(items) {
        var handles = {};
        items.forEach(function (i) { if (i.handle) handles[i.handle] = true; });
        var cards = this.content.querySelectorAll('.cu-card');
        var visible = 0;
        cards.forEach(function (card) {
          if (handles[card.dataset.handle]) {
            card.style.display = 'none';
          } else {
            card.style.display = '';
            visible++;
          }
        });
        this.hidden = visible === 0;
      }

      onClick(e) {
        var btn = e.target.closest('[data-cu-add]');
        if (!btn || btn.disabled) return;
        e.preventDefault();
        var card = btn.closest('.cu-card');

        // Single-variant product: add immediately.
        if (btn.dataset.variant) {
          this.add(btn.dataset.variant, btn);
          return;
        }

        // Multi-variant: first tap reveals the picker, second tap adds.
        var opts = card.querySelector('.cu-card__opts');
        if (opts.hasAttribute('hidden')) {
          this.buildOpts(card, opts);
          opts.hidden = false;
          btn.textContent = 'Add';
          return;
        }

        var data = this.cardData(card);
        if (!data) return;
        var selected = Array.prototype.map.call(opts.querySelectorAll('select'), function (s) { return s.value; });
        var match = data.variants.find(function (v) {
          return v.options.length === selected.length && v.options.every(function (o, i) { return o === selected[i]; });
        });
        if (!match) { this.flash(btn, 'Unavailable'); return; }
        if (!match.available) { this.flash(btn, 'Sold out'); return; }
        this.add(match.id, btn);
      }

      buildOpts(card, wrap) {
        if (wrap.dataset.built) return;
        var data = this.cardData(card);
        if (!data) return;
        data.options.forEach(function (opt, idx) {
          var sel = document.createElement('select');
          sel.setAttribute('data-cu-opt', idx);
          sel.setAttribute('aria-label', opt.name || ('Option ' + (idx + 1)));
          (opt.values || []).forEach(function (val) {
            var o = document.createElement('option');
            o.value = val;
            o.textContent = val;
            sel.appendChild(o);
          });
          wrap.appendChild(sel);
        });
        wrap.dataset.built = '1';
      }

      cardData(card) {
        try {
          return JSON.parse(card.querySelector('[data-cu-data]').textContent);
        } catch (e) {
          return null;
        }
      }

      add(variantId, btn) {
        var self = this;
        var orig = btn.dataset.label || btn.textContent.trim();
        btn.dataset.label = orig;
        btn.disabled = true;
        btn.textContent = 'Adding...';
        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        })
          .then(function (r) { return r.json(); })
          .then(function (res) {
            if (res && res.status) { throw res; }
            btn.textContent = 'Added';
            // Rebuild the drawer + refresh the free shipping bar / this strip.
            document.dispatchEvent(new CustomEvent('ajaxProduct:added', { bubbles: true }));
            document.dispatchEvent(new CustomEvent('cart:build'));
            setTimeout(function () { btn.disabled = false; btn.textContent = orig; }, 1200);
          })
          .catch(function () {
            btn.disabled = false;
            self.flash(btn, 'Try again');
          });
      }

      flash(btn, msg) {
        var orig = btn.dataset.label || btn.textContent.trim();
        btn.dataset.label = orig;
        btn.textContent = msg;
        setTimeout(function () { btn.textContent = orig; }, 1300);
      }
    }

    if (!customElements.get('cart-upsell')) {
      customElements.define('cart-upsell', CartUpsell);
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["element.select"] && !Shopify.designMode) return;
  try {
    // Custom element for select button functionality
  class ElementSelect extends HTMLElement {
    constructor() {
      super();
      this.select = null;
      this.buttonText = null;
      this.button = null;
    }

    connectedCallback() {
      // Wait for DOM to be ready
      this.select = this.querySelector('select');
      this.button = this.querySelector('.element-button');
      
      if (this.select && this.button) {
        this.init();
      }
    }

    init() {
      // Find the button text element within the element.button
      this.buttonText = this.button.querySelector('.element-button__text') || this.button.querySelector('[data-button-text]');
      
      // Set initial text
      this.updateButtonText();
      
      // Add click handler to button to trigger select
      this.button.addEventListener('click', (e) => this.handleButtonClick(e));
      
      // Add keyboard handler for the select element
      this.select.addEventListener('keydown', (e) => this.handleKeydown(e));
      
      // Update on change
      this.select.addEventListener('change', () => this.updateButtonText());
      
      // Update on focus for better UX
      this.select.addEventListener('focus', () => this.handleFocus());
      this.select.addEventListener('blur', () => this.handleBlur());
    }

    handleButtonClick(e) {
      // Prevent default button behavior
      e.preventDefault();
      e.stopPropagation();
      
      // Trigger the native select
      this.select.focus();
      this.select.click();
    }

    handleKeydown(e) {
      // Handle keyboard navigation for the select
      switch (e.key) {
        case 'Enter':
        case ' ':
          e.preventDefault();
          this.select.click();
          break;
        case 'ArrowDown':
        case 'ArrowUp':
          // Let the native select handle arrow key navigation
          break;
        default:
          // Let other keys pass through
          break;
      }
    }

    updateButtonText() {
      if (!this.buttonText) return;
      
      const selectedOption = this.select.options[this.select.selectedIndex];
      if (selectedOption && selectedOption.value !== '') {
        this.buttonText.textContent = selectedOption.textContent;
      } else {
        this.buttonText.textContent = this.select.getAttribute('aria-label') || 'Select an option';
      }
    }

    handleFocus() {
      this.classList.add('element-select__wrapper--focused');
    }

    handleBlur() {
      this.classList.remove('element-select__wrapper--focused');
    }

    disconnectedCallback() {
      // Clean up event listeners
      if (this.button) {
        this.button.removeEventListener('click', (e) => this.handleButtonClick(e));
      }
      if (this.select) {
        this.select.removeEventListener('keydown', (e) => this.handleKeydown(e));
        this.select.removeEventListener('change', () => this.updateButtonText());
        this.select.removeEventListener('focus', () => this.handleFocus());
        this.select.removeEventListener('blur', () => this.handleBlur());
      }
    }
  }

  // Register the custom element
  customElements.define('element-select', ElementSelect);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["form.product"] && !Shopify.designMode) return;
  try {
    class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.submitButton = this.findSubmitButton();
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    }

    findSubmitButton() {
      // Look for submit button in the form
      const submitButton = this.form.querySelector('button[type="submit"], input[type="submit"]');
      return submitButton;
    }

    disableSubmitButton() {
      if (this.submitButton) {
        this.submitButton.disabled = true;
        this.submitButton.classList.add('product-form__submit-button--pulsing');
      }
    }

    enableSubmitButton() {
      if (this.submitButton) {
        this.submitButton.disabled = false;
        this.submitButton.classList.remove('product-form__submit-button--pulsing');
      }
    }

    async onSubmitHandler(evt) {
      evt.preventDefault();

      // Disable submit button and start pulsing
      this.disableSubmitButton();

      // Get cart state before form submission
      let cartBeforeSubmission;
      try {
        const cartResponse = await fetch(`${window.Shopify.routes.root}cart.js`);
        cartBeforeSubmission = await cartResponse.json();
      } catch (error) {
        console.error('Failed to get cart state before submission:', error);
        cartBeforeSubmission = null;
      }

      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
        },
      };

      const formData = new FormData(this.form);

      // Dispatch event allowing subscribers to modify formData
      this.dispatchEvent(
        new CustomEvent('product-form:submit:before', {
          bubbles: true,
          detail: {
            form: formData,
          },
          cancelable: true
        })
      );

      // Wait for the next tick to allow async event listeners to complete
      // This ensures all synchronous and microtask listeners have finished
      await new Promise(resolve => {
        // Use queueMicrotask for better performance than setTimeout
        queueMicrotask(resolve);
      });

      config.body = formData;

      // Dispatch event allowing subscribers to handle cart request themselves
      const cartRequestEvent = new CustomEvent('product-form:cart:request', {
        bubbles: true,
        cancelable: true,
        detail: {
          form: formData,
          config: config,
          cartBefore: cartBeforeSubmission,
          resolve: (responseData) => this.resolveCartRequest(responseData),
          reject: (error) => this.rejectCartRequest(error)
        }
      });

      const cartRequestHandled = !this.dispatchEvent(cartRequestEvent);
      let responseData;

      try {
        if (cartRequestHandled) {
          // Event was cancelled, meaning a subscriber handled the cart request
          // We need to wait for them to provide the response data
          responseData = await this.waitForCartResponse();
        } else {
          // No subscriber handled it, proceed with default behavior
          const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, config);       
          responseData = await response.json();

          if (!response.ok) {
            throw responseData;
          }
        }

        // Get updated cart state after form submission
        const cartResponse = await fetch(`${window.Shopify.routes.root}cart.js`);
        const cartAfterSubmission = await cartResponse.json();

        this.dispatchEvent(
          new CustomEvent('product-form:submit:success', {
            bubbles: true,
            detail: {
              form: formData,
              response: responseData,
              cart: cartAfterSubmission
            },
          })
        );

        // Only fire cart:update if there's a change from this specific submission
        if (this.hasCartChanged(cartBeforeSubmission, cartAfterSubmission)) {
          this.dispatchEvent(
            new CustomEvent('product-form:cart:update', {
              bubbles: true,
              detail: {
                cart: cartAfterSubmission,
                form: formData,
                response: responseData
              },
            })
          );
        }

        // Navigate to cart unless prevented by another event handler
        const cartNavigationEvent = new CustomEvent('product-form:cart:navigate', {
          bubbles: true,
          cancelable: true,
          detail: {
            form: formData,
            response: responseData,
            cart: cartAfterSubmission
          }
        });

        const navigationPrevented = !this.dispatchEvent(cartNavigationEvent);
        
        if (!navigationPrevented) {
          window.location.href = `${window.Shopify.routes.root}cart`;
        }
      } catch (error) {
        this.dispatchEvent(
          new CustomEvent('product-form:submit:error', {
            bubbles: true,
            detail: {
              form: formData,
              cart: cartBeforeSubmission,
              error: error
            },
          })
        );
      } finally {
        // Re-enable submit button and stop pulsing
        this.enableSubmitButton();
      }
    }

    /**
     * Waits for a subscriber to provide cart response data after handling the cart request
     * @returns {Promise<Object>} The cart response data
     */
    waitForCartResponse() {
      return new Promise((resolve, reject) => {
        // Store the resolver for this request
        this._cartRequestResolver = { resolve, reject };
        
        // Set a timeout to prevent hanging
        const timeout = setTimeout(() => {
          if (this._cartRequestResolver) {
            delete this._cartRequestResolver;
            reject(new Error('Cart request timeout - no response received from subscriber'));
          }
        }, 30000); // 30 second timeout
        
        // Store timeout reference for cleanup
        this._cartRequestResolver.timeout = timeout;
      });
    }

    /**
     * Resolves a pending cart request with response data
     * Called by subscribers who handle the cart request
     * @param {string} requestId - The request ID from the waiting event
     * @param {Object} responseData - The cart response data
     */
    resolveCartRequest(responseData) {
      if (this._cartRequestResolver) {
        clearTimeout(this._cartRequestResolver.timeout);
        this._cartRequestResolver.resolve(responseData);
        delete this._cartRequestResolver;
      }
    }

    /**
     * Rejects a pending cart request with an error
     * Called by subscribers who handle the cart request
     * @param {string} requestId - The request ID from the waiting event
     * @param {Error} error - The error that occurred
     */
    rejectCartRequest(error) {
      if (this._cartRequestResolver) {
        clearTimeout(this._cartRequestResolver.timeout);
        this._cartRequestResolver.reject(error);
        delete this._cartRequestResolver;
      }
    }

    hasCartChanged(cartBefore, cartAfter) {
      if (!cartBefore || !cartAfter) {
        return true; // If we can't compare, assume there's a change
      }

      // Deep comparison using JSON.stringify for simplicity
      // This handles all nested changes automatically
      return JSON.stringify(cartBefore) !== JSON.stringify(cartAfter);
    }
  }

  customElements.define('product-form', ProductForm);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["form.product.messages"] && !Shopify.designMode) return;
  try {
    class ProductFormMessages extends HTMLElement {
    constructor() {
      super();
      
      // Pull localized error message from data attributes
      this.formId = this.dataset.formId;
      this.defaultErrorMessage = this.dataset.error;
      this.defaultSuccessMessage = this.dataset.success;
      
      // Create abort controller for event cleanup
      this.abortController = new AbortController();
    }

    connectedCallback() {
      // Cache the template content for better performance
      this.cacheTemplate();
      this.bindEvents();
    }

    disconnectedCallback() {
      // Clean up event listeners when component is removed
      this.abortController.abort();
    }

    cacheTemplate() {
      const template = this.querySelector('template');
      if (template) {
        this.template = template.innerHTML;
        this.templateElement = template;
      }
    }

    bindEvents() {
      const { signal } = this.abortController;
      
      // Listen for form submission start to clear error messages
      document.addEventListener('product-form:submit:before', this.handleSubmitStart.bind(this), { signal });
      
      // Listen for form errors
      document.addEventListener('product-form:submit:error', this.handleError.bind(this), { signal });

      // Listen for form success
      document.addEventListener('product-form:submit:success', this.handleSuccess.bind(this), { signal });
    }

    handleSubmitStart(e) {
      if (e.target.form.getAttribute('id') !== this.formId) {
        return;
      }

      this.clearMessages();
    }

    handleSuccess(e) {
      if (e.target.form.getAttribute('id') !== this.formId) {
        return;
      }

      let message = this.defaultSuccessMessage;

      const successMessageEvent = new CustomEvent('product-form:message:success', {
        bubbles: true,
        cancelable: true,
        detail: {
          form: e.target.form,
          response: e.detail.response,
          cart: e.detail.cart,
          message: message
        }
      });

      // Dispatch the event and check if it was cancelled
      const eventCancelled = !this.dispatchEvent(successMessageEvent);

      if (eventCancelled) {
        return;
      }

      this.showMessage(successMessageEvent.detail.message);
    }

    handleError(e) { 
      if (e.target.form.getAttribute('id') !== this.formId) {
        return;
      }

      const error = e.detail.error;
      let message = this.defaultErrorMessage;
      
      // Use server response message if available (already localized)
      if (error.description) {
        message = error.description;
      } else if (error.message) {
        message = error.message;
      }

      const errorMessageEvent = new CustomEvent('product-form:message:error', {
        bubbles: true,
        cancelable: true,
        detail: {
          form: e.target.form,
          response: e.detail.response,
          cart: e.detail.cart,
          message: message
        }
      });

      const eventCancelled = !this.dispatchEvent(errorMessageEvent);

      if (eventCancelled) {
        return;
      }

      this.showMessage(errorMessageEvent.detail.message);
    }

    showMessage(message) {
      // Clear existing error messages
      this.clearMessages();
      this.classList.remove('hide');
      
      // Use cached template content and replace <slot> with the error message
      if (this.template) {
        const messageContent = this.template.replace('<slot></slot>', message);
        
        // Insert the error message content
        this.innerHTML = messageContent;
      }
    }

    clearMessages() {
      this.classList.add('hide');

      // Restore the original template structure using cached template
      if (this.templateElement) {
        this.innerHTML = this.templateElement.outerHTML;
      }
    }
  }

  customElements.define('product-form-messages', ProductFormMessages);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["free-shipping-bar"] && !Shopify.designMode) return;
  try {
    (function () {
    var CHECK = '<svg class="fsb__check" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M20 6 9 17l-5-5"/></svg>';

    function formatMoney(cents) {
      if (window.theme && theme.Currency && theme.Currency.formatMoney) {
        return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
      }
      return 'R' + Math.round(cents / 100);
    }

    class FreeShippingBar extends HTMLElement {
      connectedCallback() {
        if (this._init) return;
        this._init = true;
        this.threshold = parseInt(this.dataset.threshold, 10) || 0;
        this.msg = this.querySelector('[data-fsb-msg]');
        this.fill = this.querySelector('[data-fsb-fill]');
        this.track = this.querySelector('.fsb__track');
        this._sync = this.sync.bind(this);
        // This theme uses several cart code paths: an ADD fires `ajaxProduct:added`
        // (+ `drawerOpen`) with no cart payload, while qty/remove fire `cart:updated`
        // with the cart. Listen to all of them and read the true total from /cart.js
        // so the bar is always accurate regardless of how the cart changed.
        this._events = ['cart:updated', 'product-form:cart:update', 'ajaxProduct:added', 'drawerOpen', 'cart:build'];
        this._events.forEach(function (ev) { document.addEventListener(ev, this._sync); }, this);
        this.sync();
      }

      disconnectedCallback() {
        if (this._events) {
          this._events.forEach(function (ev) { document.removeEventListener(ev, this._sync); }, this);
        }
      }

      sync(evt) {
        // Fast path: cart:updated / product-form:cart:update already carry the cart.
        var cart = evt && evt.detail && evt.detail.cart;
        if (cart && typeof cart.total_price === 'number') {
          this.render(cart.total_price);
          return;
        }
        // Otherwise fetch the source of truth, debounced (one add can fire
        // several of these events at once).
        var self = this;
        clearTimeout(this._t);
        this._t = setTimeout(function () {
          fetch(window.Shopify.routes.root + 'cart.js', { headers: { 'Accept': 'application/json' } })
            .then(function (r) { return r.json(); })
            .then(function (c) { self.render(c.total_price); })
            .catch(function () {});
        }, 60);
      }

      render(totalCents) {
        var remaining = Math.max(0, this.threshold - totalCents);
        var pct = this.threshold > 0 ? (totalCents / this.threshold) * 100 : 0;
        pct = Math.max(0, Math.min(100, pct));
        var unlocked = totalCents >= this.threshold;

        if (this.fill) this.fill.style.width = pct + '%';
        if (this.track) this.track.setAttribute('aria-valuenow', Math.round(pct));
        this.classList.toggle('fsb--unlocked', unlocked);

        if (this.msg) {
          if (unlocked) {
            this.msg.innerHTML = CHECK + ' Free shipping unlocked';
          } else {
            this.msg.innerHTML = "You're <strong>" + formatMoney(remaining) + "</strong> away from free shipping";
          }
        }

        // Celebrate only the moment it flips locked -> unlocked (not every render,
        // and not on initial load if the cart already qualifies).
        if (unlocked && this._wasUnlocked === false) {
          this.celebrate();
        }
        this._wasUnlocked = unlocked;
      }

      celebrate() {
        var el = this;
        el.classList.remove('fsb--celebrate');
        void el.offsetWidth; // force reflow so the animation restarts each time
        el.classList.add('fsb--celebrate');
        clearTimeout(this._celebrateT);
        this._celebrateT = setTimeout(function () {
          el.classList.remove('fsb--celebrate');
        }, 900);
      }
    }

    if (!customElements.get('free-shipping-bar')) {
      customElements.define('free-shipping-bar', FreeShippingBar);
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["layout.grid"] && !Shopify.designMode) return;
  try {
    class LayoutGrid extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.attachShadowRoots(this);
    }

    attachShadowRoots(element) {
      if (this.shadowRoot) {
        return;
      }
      
      element.querySelectorAll("template[shadowrootmode]").forEach(template => {
        const mode = template.getAttribute("shadowrootmode");
        const shadowRoot = template.parentNode.attachShadow({ mode });

        shadowRoot.appendChild(template.content);
        template.remove();
        this.attachShadowRoots(shadowRoot);
      });
    }
  }

  customElements.define('layout-grid', LayoutGrid);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["layout.stack"] && !Shopify.designMode) return;
  try {
    class LayoutStack extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.attachShadowRoots(this);
    }

    attachShadowRoots(element) {
      if (this.shadowRoot) {
        return;
      }
      
      element.querySelectorAll("template[shadowrootmode]").forEach(template => {
        const mode = template.getAttribute("shadowrootmode");
        const shadowRoot = template.parentNode.attachShadow({ mode });

        shadowRoot.appendChild(template.content);
        template.remove();
        this.attachShadowRoots(shadowRoot);
      });
    }
  }

  customElements.define('layout-stack', LayoutStack);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["layout.sticky-scroller"] && !Shopify.designMode) return;
  try {
    class StickyScroller extends HTMLElement {
    constructor() {
      super()
      this.resizeObserver = new ResizeObserver(() => this.recalculateStyles())
      this.abortController = new AbortController()
      this.isScrolling = false
      this.position = 'relative'
      this.lastKnownScrollY = 0
      this.initialTop = 0
      this.currentTop = 0
      this.boundOnScroll = this.onScroll.bind(this)
    }

    connectedCallback() {
      this.inView(this, this.setupObservers.bind(this), { margin: '500px' })
    }

    disconnectedCallback() {
      this.cleanupObservers()
    }

    setupObservers() {
      this.resizeObserver.observe(this)
      window.addEventListener('scroll', this.boundOnScroll, { passive: true, signal: this.abortController.signal })
      return this.cleanupObservers.bind(this)
    }

    cleanupObservers() {
      this.abortController.abort()
      this.resizeObserver.disconnect()
    }

    onScroll() {
      if (!this.isScrolling) {
        requestAnimationFrame(() => {
          this.updatePosition()
          this.isScrolling = false
        })
        this.isScrolling = true
      }
    }

    recalculateStyles() {
      this.style.removeProperty('top')
      const { top, position } = getComputedStyle(this)
      this.initialTop = parseInt(top, 10)
      this.position = position
      this.updatePosition()
    }

    updatePosition() {
      if (this.position !== 'sticky') {
        this.style.removeProperty('top')
        return
      }

      const { top, height } = this.getBoundingClientRect()
      const maxTop = top + window.scrollY - this.offsetTop + this.initialTop
      const minTop = height - window.innerHeight + 20

      this.currentTop += this.lastKnownScrollY - window.scrollY
      this.currentTop = Math.min(Math.max(this.currentTop, -minTop), maxTop, this.initialTop)

      this.lastKnownScrollY = window.scrollY
      this.style.top = `${Math.round(this.currentTop)}px`
    }
    
    /**
     * Original source from https://www.npmjs.com/package/@motionone/dom
     * Usage: https://motion.dev/dom/in-view
     */
    inView(elementOrSelector, onStart, { root, margin: rootMargin, amount = 'any' } = {}) {
      const thresholds = {
        any: 0,
        all: 1
      }

      if (typeof IntersectionObserver === 'undefined') {
        return () => {}
      }

      let elements
      if (typeof elementOrSelector === 'string') {
        elements = document.querySelectorAll(elementOrSelector)
      } else if (elementOrSelector instanceof Element) {
        elements = [elementOrSelector]
      } else {
        elements = Array.from(elementOrSelector || [])
      }

      const activeIntersections = new WeakMap()
      const onIntersectionChange = (entries) => {
        entries.forEach((entry) => {
          const onEnd = activeIntersections.get(entry.target)
          if (entry.isIntersecting === Boolean(onEnd)) return
          if (entry.isIntersecting) {
            const newOnEnd = onStart(entry)
            if (typeof newOnEnd === 'function') {
              activeIntersections.set(entry.target, newOnEnd)
            } else {
              observer.unobserve(entry.target)
            }
          } else if (onEnd) {
            onEnd(entry)
            activeIntersections.delete(entry.target)
          }
        })
      }

      const observer = new IntersectionObserver(onIntersectionChange, {
        root,
        rootMargin,
        threshold: typeof amount === 'number' ? amount : thresholds[amount]
      })

      elements.forEach((element) => observer.observe(element))
      return () => observer.disconnect()
    }
  }

  customElements.define('sticky-scroller', StickyScroller)
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["overlay.drawer"] && !Shopify.designMode) return;
  try {
    class OverlayDrawer extends HTMLElement {
    constructor() {
      super();
      
      
      
      // Store arrow functions to ensure same reference for add/remove
    }

    connectedCallback() {
      this.closeButton = null;
      this.triggers = null;
      this.previouslyFocused = document.activeElement;
      this.trapFocusHandlers = {};
      this.abortController = new AbortController();
      this.closeButton = this.querySelector('[data-drawer-close-button]');
      this.triggers = document.querySelectorAll(
        `[data-open-drawer="${this.id}"]`
      );

      const signal = this.abortController.signal;
      
      this.moveToBody();

      this.closeButton.addEventListener('click', () => this.close(), { signal });
      this.triggers.forEach((trigger) => {
        trigger.addEventListener('click', (event) => {
          event.preventDefault();
          this.open();
        }, { signal });
      });
      document.addEventListener('keydown', (event) => this.handleKeydown(event), { signal });
      this.addEventListener('click', (event) => this.handleOverlayClick(event), { signal });
    }

    disconnectedCallback() {
      this.abortController.abort();
    }

    open() {
      this.previouslyFocused = document.activeElement;
      
      this.setAttribute('open', 'true');
      this.trapFocus(this);
    }

    close() {
      this.setAttribute('open', 'false');
      this.removeTrapFocus(this.previouslyFocused);
    }

    moveToBody() {
      if (this.parentNode === document.body) return;
      
      // Store the original parent and next sibling for potential restoration
      this.originalParent = this.parentNode;
      this.originalNextSibling = this.nextSibling;
      
      // Move the element to the body
      document.body.appendChild(this);
    }

    handleOverlayClick(event) {
      if (event.target === this) this.close();
    }

    handleKeydown(event) {
      if (event.key === 'Escape' && this.getAttribute('open') === 'true') {
        this.close();
      }
    }

    removeTrapFocus(elementToFocus = null) {
      if (this.trapFocusAbortController) {
        this.trapFocusAbortController.abort();
        this.trapFocusAbortController = null;
      }

      if (elementToFocus) {
        try {
          elementToFocus.focus({ preventScroll: true })
        } catch (e) {
          elementToFocus.focus()
        }
      }
    }

    forceFocus(element, options = {}) {
      let savedTabIndex = element.tabIndex

      element.tabIndex = -1
      element.dataset.tabIndex = savedTabIndex
      element.focus()
      if (typeof options.className !== 'undefined') {
        element.classList.add(options.className)
      }
      element.addEventListener('blur', callback)

      function callback(event) {
        event.target.removeEventListener(event.type, callback)

        element.tabIndex = savedTabIndex
        delete element.dataset.tabIndex
        if (typeof options.className !== 'undefined') {
          element.classList.remove(options.className)
        }
      }
    }

    focusable(container) {
      return Array.from(
        container.querySelectorAll(
          "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
        )
      )
    }

    trapFocus(container, options = {}) {
      let elements = this.focusable(container)
      let elementToFocus = options.elementToFocus || container
      let first = elements[0]
      let last = elements[elements.length - 1]

      this.removeTrapFocus()

      // Create new AbortController for focus trap events
      this.trapFocusAbortController = new AbortController();
      const signal = this.trapFocusAbortController.signal;

      this.trapFocusHandlers.focusin = function (event) {
        if (container !== event.target && !container.contains(event.target)) {
          this.forceFocus(first || container, options)
        }

        if (event.target !== container && event.target !== last && event.target !== first) return
        document.addEventListener('keydown', this.trapFocusHandlers.keydown, { signal })
      }.bind(this)

      this.trapFocusHandlers.focusout = function () {
        document.removeEventListener('keydown', this.trapFocusHandlers.keydown)
      }.bind(this)

      this.trapFocusHandlers.keydown = function (event) {
        if (event.keyCode !== 9) return // If not TAB key

        // On the last focusable element and tab forward, focus the first element.
          if (event.target === last && !event.shiftKey) {
        event.preventDefault()
        this.forceFocus(first || container, options)
      }

        //  On the first focusable element and tab backward, focus the last element.
          if ((event.target === container || event.target === first) && event.shiftKey) {
        event.preventDefault()
        this.forceFocus(last || container, options)
      }
      }.bind(this)

      document.addEventListener('focusout', this.trapFocusHandlers.focusout, { signal })
      document.addEventListener('focusin', this.trapFocusHandlers.focusin, { signal })

      this.forceFocus(elementToFocus, options)
    }
  }

  customElements.define('overlay-drawer', OverlayDrawer);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["overlay.lightbox"] && !Shopify.designMode) return;
  try {
    class OverlayLightbox extends HTMLElement {
    // Static registry to track all lightbox instances
    static registry = new Map();
    // Track which groups have been prefetched
    static prefetchedGroups = new Set();

    constructor() {
      super();
      this.trigger = null;
      this.template = null;
      this.overlay = null;
      this.closeBtn = null;
      this.prevBtn = null;
      this.nextBtn = null;
      this.group = this.dataset.group;
      this.groupItems = [];
      this.currentIndex = 0;

      // Register this instance
      if (this.group) { 
        if (!OverlayLightbox.registry.has(this.group)) {
          OverlayLightbox.registry.set(this.group, []);
        }
        OverlayLightbox.registry.get(this.group).push(this);
      }
    }

    connectedCallback() {
      // Initialize elements when connected to DOM
      this.trigger = this.querySelector('.overlay-lightbox__trigger');
      this.template = this.querySelector('.overlay-lightbox__template');
      this.init();
    }

    init() {
      // Open lightbox on trigger click
      if (this.trigger) {
        this.trigger.addEventListener('click', (e) => {
          e.preventDefault();
          this.openLightbox();
        });
      }


      // Handle ESC key globally
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.isOpen()) {
          this.closeLightbox();
        } else if (this.isOpen() && this.group) {
          if (e.key === 'ArrowLeft') {
            e.preventDefault();
            this.navigateToPrevious();
          } else if (e.key === 'ArrowRight') {
            e.preventDefault();
            this.navigateToNext();
          }
        }
      });
    }

    openLightbox() {
      // Create overlay if it doesn't exist
      if (!this.overlay) {
        this.createOverlay();
      }

      this.overlay.classList.add('overlay-lightbox__overlay--open');
      document.body.style.overflow = 'hidden';

      // If this is part of a group, find all group items
      if (this.group) {
        this.findGroupItems();

        // Prefetch images for the group
        this.prefetchGroupImages();

        // Add single-item class if there's only one item in the group
        if (this.groupItems.length <= 1) {
          this.overlay.classList.add('overlay-lightbox__overlay--single-item');
        } else {
          this.overlay.classList.remove('overlay-lightbox__overlay--single-item');
        }
      } else {
        // No group, so hide navigation buttons
        this.overlay.classList.add('overlay-lightbox__overlay--single-item');
      }
    }

    createOverlay() {
      // Check if template exists
      if (!this.template) {
        console.error('OverlayLightbox: Template not found');
        return;
      }

      // Clone the template content
      this.overlay = this.template.content.cloneNode(true).querySelector('.overlay-lightbox__overlay');
      
      // Check if overlay was created successfully
      if (!this.overlay) {
        console.error('OverlayLightbox: Overlay element not found in template');
        return;
      }
      
      // Get references to buttons
      this.closeBtn = this.overlay.querySelector('.lightbox-close');
      this.prevBtn = this.overlay.querySelector('.overlay-lightbox__nav--prev');
      this.nextBtn = this.overlay.querySelector('.overlay-lightbox__nav--next');

      // Add event listeners
      if (this.closeBtn) {
        this.closeBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.closeLightbox();
        });
      }

      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.navigateToPrevious();
        });
      }

      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.navigateToNext();
        });
      }

      // Close lightbox when clicking outside content
      if (this.overlay) {
        this.overlay.addEventListener('click', (e) => {
          if (e.target === this.overlay) {
            this.closeLightbox();
          }
        });
      }

      // Append to body
      if (this.overlay) {
        document.body.appendChild(this.overlay);
      }
    }

    closeLightbox() {
      if (this.overlay) {
        this.overlay.classList.remove('overlay-lightbox__overlay--open');
        this.overlay.classList.remove('overlay-lightbox__overlay--single-item');
        
        // Remove overlay immediately
        if (this.overlay.parentNode) {
          this.overlay.parentNode.removeChild(this.overlay);
          this.overlay = null;
          this.closeBtn = null;
          this.prevBtn = null;
          this.nextBtn = null;
        }
      }
      
      document.body.style.overflow = '';
    }


    findGroupItems() {
      // Use the static registry to find group items
      this.groupItems = OverlayLightbox.registry.get(this.group) || [];
      this.currentIndex = this.groupItems.indexOf(this);
    }

    navigateToPrevious() {
      if (!this.group || this.groupItems.length <= 1) return;

      let targetIndex = this.currentIndex - 1;
      if (targetIndex < 0) {
        // Loop to last item
        targetIndex = this.groupItems.length - 1;
      }

      const targetLightbox = this.groupItems[targetIndex];
      if (targetLightbox) {
        this.switchToLightbox(targetLightbox);
      }
    }

    navigateToNext() {
      if (!this.group || this.groupItems.length <= 1) return;

      let targetIndex = this.currentIndex + 1;
      if (targetIndex >= this.groupItems.length) {
        // Loop to first item
        targetIndex = 0;
      }

      const targetLightbox = this.groupItems[targetIndex];
      if (targetLightbox) {
        this.switchToLightbox(targetLightbox);
      }
    }

    switchToLightbox(targetLightbox) {
      // Close current lightbox
      this.closeLightbox();
      
      // Open target lightbox immediately
      targetLightbox.openLightbox();
    }

    prefetchGroupImages() {
      // Only prefetch once per group
      if (this.group && !OverlayLightbox.prefetchedGroups.has(this.group)) {
        OverlayLightbox.prefetchedGroups.add(this.group);
        
        this.groupItems.forEach(lightbox => {
          // Find all images in this lightbox's content
          const images = lightbox.querySelectorAll('img');
          images.forEach(img => {
            // Prefetch the largest available image
            this.prefetchLargestImage(img);
          });
        });
      }
    }

    prefetchLargestImage(img) {
      // Try to get the largest image from srcset first
      if (img.srcset) {
        const srcsetUrls = img.srcset.split(',').map(src => src.trim().split(' ')[0]);
        // Find the largest size (highest number in the URL)
        let largestUrl = img.src;
        let largestSize = 0;
        
        srcsetUrls.forEach(url => {
          const size = this.extractImageSize(url);
          if (size > largestSize) {
            largestSize = size;
            largestUrl = url;
          }
        });
        
        this.prefetchImage(largestUrl);
      } else {
        // No srcset, try to get largest size from original URL
        const largestUrl = this.getLargestImageUrl(img.src);
        this.prefetchImage(largestUrl);
      }
    }

    extractImageSize(url) {
      try {
        const urlObj = new URL(url);
        
        // Check for width parameter
        if (urlObj.searchParams.has('width')) {
          return parseInt(urlObj.searchParams.get('width')) || 0;
        }
        
        // Check for underscore format (image_2400x.jpg)
        const pathParts = urlObj.pathname.split('_');
        if (pathParts.length > 1) {
          const sizeMatch = pathParts[pathParts.length - 1].match(/(\d+)x/);
          if (sizeMatch) {
            return parseInt(sizeMatch[1]) || 0;
          }
        }
      } catch (e) {
        // URL parsing failed
      }
      
      return 0;
    }

    getLargestImageUrl(originalUrl) {
      try {
        const url = new URL(originalUrl);
        
        // Handle Shopify image URLs - try to get 2400px version
        if (url.searchParams.has('width')) {
          url.searchParams.set('width', '2400');
          return url.toString();
        } else if (url.pathname.includes('_')) {
          // Handle Shopify's underscore format
          const pathParts = url.pathname.split('_');
          if (pathParts.length > 1) {
            const extension = pathParts[pathParts.length - 1].split('.')[1] || 'jpg';
            const newPath = pathParts.slice(0, -1).join('_') + '_2400x.' + extension;
            url.pathname = newPath;
            return url.toString();
          }
        }
      } catch (e) {
        // If URL parsing fails, return original
      }
      
      return originalUrl;
    }

    prefetchImage(url) {
      const prefetchImg = new Image();
      prefetchImg.src = url;
    }

    isOpen() {
      return this.overlay && this.overlay.classList.contains('overlay-lightbox__overlay--open');
    }

    // Clean up when element is removed
    disconnectedCallback() {
      if (this.group) {
        const groupItems = OverlayLightbox.registry.get(this.group);
        if (groupItems) {
          const index = groupItems.indexOf(this);
          if (index > -1) {
            groupItems.splice(index, 1);
          }
          // Remove empty groups
          if (groupItems.length === 0) {
            OverlayLightbox.registry.delete(this.group);
          }
        }
      }
    }
  }

  // Define the custom element
  customElements.define('overlay-lightbox', OverlayLightbox);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product.hot-reload"] && !Shopify.designMode) return;
  try {
    class ProductHotReload extends HTMLElement {
    constructor() {
      super();
      this.cache = new Map(); // Cache for pre-fetched content
      this.activeRequests = new Map(); // Track active fetch requests
      this.loadingTimeout = null; // Timeout for loading state
      this.supportsViewTransitions = 'startViewTransition' in document;
      
      this.addEventListener('change', (event) => this.onVariantChange(event));
      this.addEventListener('mouseover', (event) => this.onMouseOver(event));
    }

    showLoadingState() {
      // Start loading state (pulse) after 200ms
      this.loadingTimeout = setTimeout(() => {
        this.classList.add('product-hot-reload--loading');
      }, 200);
    }

    hideLoadingState() {
      // Clear the timeout if it hasn't triggered yet
      if (this.loadingTimeout) {
        clearTimeout(this.loadingTimeout);
        this.loadingTimeout = null;
      }
      
      // Remove loading animation
      this.classList.remove('product-hot-reload--loading');
    }

    buildRequestUrl(input) {
      const productFormElement = input.closest('form');
      const sectionId = this.dataset.sectionId;
      
      // Get dataset values from the input or selected option
      let newProductUrl, optionValueId;
      
      if (input.type === 'radio') {
        newProductUrl = input.dataset.productUrl;
        optionValueId = input.dataset.optionValueId;
      } else if (input.tagName === 'SELECT') {
        const selectedOption = input.options[input.selectedIndex];
        newProductUrl = selectedOption.dataset.productUrl;
        optionValueId = selectedOption.dataset.optionValueId;
      }

      // Get all currently selected values from both radio inputs and select elements
      let selectedOptionValues = [];
      
      // Get values from checked radio inputs
      const checkedRadios = Array.from(productFormElement.querySelectorAll('input[type="radio"]:checked'));
      selectedOptionValues = checkedRadios.map(({ dataset }) => dataset.optionValueId).filter(Boolean);
      
      // Get values from select elements
      const selects = Array.from(productFormElement.querySelectorAll('select'));
      selects.forEach(select => {
        const selectedOption = select.options[select.selectedIndex];
        if (selectedOption && selectedOption.dataset.optionValueId) {
          selectedOptionValues.push(selectedOption.dataset.optionValueId);
        }
      });

      // If we're building for a hover state, replace the current option's value
      if (input.type === 'radio' && !input.checked) {
        const currentOptionName = input.name;
        // Remove any existing selection for this option
        selectedOptionValues = selectedOptionValues.filter(id => {
          const input = productFormElement.querySelector(`input[data-option-value-id="${id}"]`);
          return input && input.name !== currentOptionName;
        });
        // Add the hovered option value
        selectedOptionValues.push(optionValueId);
      }

      const params = selectedOptionValues.length > 0 ? `&option_values=${selectedOptionValues.join(',')}` : '';
      return `${newProductUrl}?section_id=${sectionId}${params}`;
    }

    onMouseOver(event) {
      const label = event.target.closest('label');
      if (!label) return;

      const input = label.querySelector('input[type="radio"]');
      if (!input) return;

      // Don't pre-fetch if already selected
      if (input.checked) return;

      const requestUrl = this.buildRequestUrl(input);

      // Don't prefetch if we already have cached content or an active request
      if (this.cache.has(requestUrl) || this.activeRequests.has(requestUrl)) return;

      // Pre-fetch the content for this option
      this.fetchContent(requestUrl);
    }

    fetchContent(requestUrl) {
      // Create and store the fetch promise
      const fetchPromise = fetch(requestUrl)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          this.cache.set(requestUrl, html);
          this.activeRequests.delete(requestUrl);
          return html;
        })
        .catch((error) => {
          this.activeRequests.delete(requestUrl);
          throw error;
        });

      this.activeRequests.set(requestUrl, fetchPromise);
      return fetchPromise;
    }

    async onVariantChange(event) {
      if (!event.target.hasAttribute('data-product-hot-reload-trigger')) return;

      const optionValueElement = event.target;
      const requestUrl = this.buildRequestUrl(optionValueElement);
      const oldProductUrl = this.dataset.productUrl;
      
      // Get new product URL from the input or selected option
      let newProductUrl;
      if (optionValueElement.type === 'radio') {
        newProductUrl = optionValueElement.dataset.productUrl || oldProductUrl;
      } else if (optionValueElement.tagName === 'SELECT') {
        const selectedOption = optionValueElement.options[optionValueElement.selectedIndex];
        newProductUrl = selectedOption.dataset.productUrl || oldProductUrl;
      } else {
        newProductUrl = oldProductUrl;
      }

      // Start loading state immediately on change event
      this.showLoadingState();

      let html;

      try {
        // Use cached content if available
        if (this.cache.has(requestUrl)) {
          html = this.cache.get(requestUrl);
        }
        // Wait for active request if one exists
        else if (this.activeRequests.has(requestUrl)) {
          html = await this.activeRequests.get(requestUrl);
        }
        // Make new request if no cache or active request
        else {
          html = await this.fetchContent(requestUrl);
        }

        await this.updateProductWithTransition(html, newProductUrl, event.target.id);
      } catch (error) {
        console.error('Error updating product content:', error);
      } finally {
        // Always hide loading state
        this.hideLoadingState();
      }
    }

    async updateProductWithTransition(html, newProductUrl, targetId) {
      const updatedHtml = html.getElementById(this.id);
      
      if (this.supportsViewTransitions) {
        // Use View Transitions API for smooth transitions
        const transition = document.startViewTransition(() => {
          this.innerHTML = updatedHtml.innerHTML;
          this.dataset.productUrl = updatedHtml.dataset.productUrl;
          this.dataset.variantId = updatedHtml.dataset.variantId;
        });

        // Wait for the transition to complete
        await transition.finished;
      } else {
        // Fallback: Update content immediately without animations
        this.innerHTML = updatedHtml.innerHTML;
        this.dataset.productUrl = updatedHtml.dataset.productUrl;
        this.dataset.variantId = updatedHtml.dataset.variantId;
      }

      // Update URL and history
      let url = new URL(newProductUrl, window.location.origin);

      // Preserve all existing URL parameters from the current page
      const currentUrl = new URL(window.location.href);
      for (const [key, value] of currentUrl.searchParams.entries()) {
        // Don't override the variant parameter we're setting
        if (key !== 'variant') {
          url.searchParams.set(key, value);
        }
      }

      // Add variant param if variantId exists
      url.searchParams.set('variant', this.dataset.variantId);

      // Push new state to browser history
      window.history.pushState({}, '', url.toString());

      // Focus the input for the last clicked option value
      this.querySelector(`#${targetId}`).focus();
    }
  }

  customElements.define('product-hot-reload', ProductHotReload);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["section.flex-pdp.gift-recipient"] && !Shopify.designMode) return;
  try {
    class GiftRecipientForm extends HTMLElement {
    constructor() {
      super()
      this.checkboxInput = this.querySelector('.gift-recipient-form__checkbox input[type="checkbox"]')
      this.emailInput = this.querySelector('.gift-recipient-form__email')
      this.nameInput = this.querySelector('.gift-recipient-form__name')
      this.messageInput = this.querySelector('.gift-recipient-form__message')
      this.dateInput = this.querySelector('.gift-recipient-form__date')
      this.addEventListener('change', () => this.onChange())
      this.recipientFields = this.querySelector('.recipient-fields')

      this.checkboxInput.addEventListener('change', () => {
        event.stopPropagation()
        this.recipientFields.style.display = this.checkboxInput.checked ? 'block' : 'none'
      })
    }

    connectedCallback() {
      this.abortController = new AbortController()

      document.addEventListener('product-form:submit:error', (event) => {
        if (event.target.form.id === this.dataset.formId) {
          this.displayErrorMessage(event.detail.errorMessage)
        }
      }, { signal: this.abortController.signal })

      document.addEventListener('product-form:submit:success', (event) => {
        if (event.target.form.id === this.dataset.formId) {
          this.clearInputFields()
          this.clearErrorMessage()
        }
      }, { signal: this.abortController.signal })
    }

    disconnectedCallback() {
      this.abortController.abort()
    }

    onChange() {
      if (!this.checkboxInput.checked) {
        this.clearInputFields()
        this.clearErrorMessage()
      }
    }

    clearInputFields() {
      for (const element of this.querySelectorAll('input')) {
        element.value = ''
      }
    }

    displayErrorMessage(body) {
      this.clearErrorMessage()
      if (body) {
        return Object.entries(body).forEach(([key, value]) => {
          const inputElement = this[`${key}Input`]
          if (!inputElement) {
            return
          }

          inputElement.setAttribute('aria-invalid', true)
        })
      }
    }

    clearErrorMessage() {
      for (const inputElement of this.querySelectorAll('input')) {
        inputElement.setAttribute('aria-invalid', false)
        inputElement.removeAttribute('aria-describedby')
      }
    }
  }

  customElements.define('gift-recipient-form', GiftRecipientForm)
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["section.flex-pdp.media-gallery"] && !Shopify.designMode) return;
  try {
    class MediaGalleryElement extends HTMLElement {
    constructor() {
      super();
      this.slides = this.querySelectorAll('.media-gallery__slide');
      this.thumbs = this.querySelectorAll('.media-gallery__thumb');
      this.prevBtn = this.querySelector('.media-gallery__nav--prev');
      this.nextBtn = this.querySelector('.media-gallery__nav--next');
      this.mainContainer = this.querySelector('.media-gallery__main');
      this.currentIndex = 0;
      this.isAnimating = false;
      this.isNaturalAspectRatio = this.mainContainer?.getAttribute('data-aspect-ratio') === 'initial';

      // Touch/swipe handling
      this.touchStartX = 0;
      this.touchStartY = 0;
      this.touchEndX = 0;
      this.touchEndY = 0;
      this.minSwipeDistance = 50;
    }

    connectedCallback() {
      this.init();
    }

    init() {
      // Adjust container height for natural aspect ratio
      if (this.isNaturalAspectRatio) {
        this.adjustContainerHeight(true); // Disable transition for initial setup

        // Set up resize observer for images that might load asynchronously
        this.setupResizeObserver();
      }

      // Add click handlers to thumbnails
      this.thumbs.forEach((thumb, index) => {
        thumb.addEventListener('click', () => {
          const direction = index > this.currentIndex ? 'next' : 'prev';
          this.goToSlide(index, direction);
        });
      });

      // Add click handlers to navigation buttons
      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.previousSlide();
        });
      }

      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.nextSlide();
        });
      }

      // Add keyboard navigation
      this.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') {
          e.preventDefault();
          this.previousSlide();
        } else if (e.key === 'ArrowRight') {
          e.preventDefault();
          this.nextSlide();
        }
      });

      // Make the gallery focusable for keyboard navigation
      this.setAttribute('tabindex', '0');

      // Add touch/swipe handlers
      this.addEventListener('touchstart', this.handleTouchStart.bind(this), { passive: true });
      this.addEventListener('touchend', this.handleTouchEnd.bind(this), { passive: true });
      this.addEventListener('touchmove', this.handleTouchMove.bind(this), { passive: true });

      // Ensure only the initial active slide can play
      this.pauseNonActiveSlides();
      this.autoplayActiveSlideIfEligible();
    }

    goToSlide(index, direction = 'next') {
      if (index < 0 || index >= this.slides.length) return;
      if (index === this.currentIndex) return;
      if (this.isAnimating) return;

      const currentSlide = this.slides[this.currentIndex];
      const targetSlide = this.slides[index];

      // Before animating, pause non-target slides
      this.pauseAllMediaExceptInSlide(targetSlide);

      // Reset all slides
      this.resetSlides();

      // Position slides for animation
      this.positionSlidesForAnimation(currentSlide, targetSlide, direction);

      // Update UI state
      this.updateThumbnails(index);
      this.currentIndex = index;

      // Start animation after positioning is applied
      this.animateSlides(currentSlide, targetSlide, direction);

      // Adjust container height for natural aspect ratio after slide change
      if (this.isNaturalAspectRatio) {
        setTimeout(() => {
          this.adjustContainerHeight();
        }, 50); // Small delay to ensure slide is positioned
      }
    }

    resetSlides() {
      this.slides.forEach(slide => {
        slide.classList.remove('media-gallery__slide--prev', 'media-gallery__slide--next');
      });
    }

    positionSlidesForAnimation(currentSlide, targetSlide, direction) {
      // Remove animation class from all slides during positioning
      this.slides.forEach(slide => {
        slide.classList.remove('media-gallery__slide--is-animating');
      });

      if (direction === 'next') {
        // Next: target and others on right, current stays in center
        targetSlide.style.transform = 'translateX(100%)';
        this.slides.forEach(slide => {
          if (slide !== currentSlide && slide !== targetSlide) {
            slide.style.transform = 'translateX(100%)';
          }
        });
      } else {
        // Previous: target and others on left, current stays in center
        targetSlide.style.transform = 'translateX(-100%)';
        this.slides.forEach(slide => {
          if (slide !== currentSlide && slide !== targetSlide) {
            slide.style.transform = 'translateX(-100%)';
          }
        });
      }
    }

    updateThumbnails(activeIndex) {
      this.thumbs[this.currentIndex].classList.remove('media-gallery__thumb--active');
      this.thumbs[activeIndex].classList.add('media-gallery__thumb--active');
    }

    adjustContainerHeight(disableTransition = false) {
      if (!this.isNaturalAspectRatio || !this.mainContainer) return;

      const activeSlide = this.slides[this.currentIndex];
      if (!activeSlide) return;

      // Disable transition if requested (for initial setup)
      if (disableTransition) {
        this.mainContainer.classList.add('media-gallery__main--no-transition');
      }

      // Find the image in the active slide
      const img = activeSlide.querySelector('img');
      if (!img) return;

      // Get the image's natural dimensions
      const imgWidth = img.naturalWidth || img.width;
      const imgHeight = img.naturalHeight || img.height;

      if (imgWidth && imgHeight) {
        // Calculate the aspect ratio
        const aspectRatio = imgWidth / imgHeight;

        // Get the container width
        const containerWidth = this.mainContainer.offsetWidth;

        // Calculate the height based on the aspect ratio
        const calculatedHeight = containerWidth / aspectRatio;

        // Set the container height
        this.mainContainer.style.height = calculatedHeight + 'px';
      } else {
        // Fallback: temporarily make the slide visible to measure its height
        const originalOpacity = activeSlide.style.opacity;
        const originalTransform = activeSlide.style.transform;
        activeSlide.style.opacity = '1';
        activeSlide.style.transform = 'translateX(0)';
        activeSlide.style.position = 'relative';
        activeSlide.style.visibility = 'hidden';

        // Get the natural height of the slide content
        const slideHeight = activeSlide.offsetHeight;

        // Restore original styles
        activeSlide.style.opacity = originalOpacity;
        activeSlide.style.transform = originalTransform;
        activeSlide.style.position = '';
        activeSlide.style.visibility = '';

        // Set the container height to match the slide height
        this.mainContainer.style.height = slideHeight + 'px';
      }

      // Re-enable transition after a brief delay
      if (disableTransition) {
        setTimeout(() => {
          this.mainContainer.classList.remove('media-gallery__main--no-transition');
        }, 10);
      }
    }

    setupResizeObserver() {
      if (!this.isNaturalAspectRatio || !window.ResizeObserver) return;

      this.resizeObserver = new ResizeObserver(() => {
        this.adjustContainerHeight();
      });

      // Observe all images in the slides
      this.slides.forEach(slide => {
        const images = slide.querySelectorAll('img');
        images.forEach(img => {
          this.resizeObserver.observe(img);

          // Also listen for load events to recalculate when image loads
          img.addEventListener('load', () => {
            if (slide.classList.contains('media-gallery__slide--active')) {
              this.adjustContainerHeight();
            }
          });
        });
      });
    }

    animateSlides(currentSlide, targetSlide, direction) {
      // Set animation flag
      this.isAnimating = true;

      // Frame 1: Initial positions are already set (no animation class)

      // Frame 2: Add animation class
      requestAnimationFrame(() => {
        currentSlide.classList.add('media-gallery__slide--is-animating');
        targetSlide.classList.add('media-gallery__slide--is-animating');

        // Frame 3: Trigger animation
        requestAnimationFrame(() => {
          // Animate current slide out
          if (direction === 'next') {
            currentSlide.style.transform = 'translateX(-100%)';
          } else {
            currentSlide.style.transform = 'translateX(100%)';
          }

          // Animate target slide in
          targetSlide.style.transform = 'translateX(0)';
          targetSlide.classList.add('media-gallery__slide--active');

          // Clean up after animation
          this.waitForTransition(currentSlide).then(() => {
            this.positionCurrentSlideAfterAnimation(currentSlide, targetSlide, direction);
            this.scrollActiveThumbnailIntoView();
            // Hydrate and autoplay current slide media if eligible and pause others
            this.pauseNonActiveSlides();
            this.autoplayActiveSlideIfEligible();
            // Clear animation flag
            this.isAnimating = false;
          });
        });
      });
    }

    positionCurrentSlideAfterAnimation(currentSlide, targetSlide, direction) {
      // Remove animation class and active class from current slide
      currentSlide.classList.remove('media-gallery__slide--is-animating', 'media-gallery__slide--active');
      targetSlide.classList.remove('media-gallery__slide--is-animating');

      if (direction === 'next') {
        currentSlide.style.transform = 'translateX(100%)';
      } else {
        currentSlide.style.transform = 'translateX(-100%)';
      }

      // Adjust container height for natural aspect ratio after animation
      if (this.isNaturalAspectRatio) {
        this.adjustContainerHeight();
      }
    }

    scrollActiveThumbnailIntoView() {
      this.thumbs[this.currentIndex].scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'center'
      });
    }

    nextSlide() {
      const nextIndex = (this.currentIndex + 1) % this.slides.length;
      this.goToSlide(nextIndex, 'next');
    }

    previousSlide() {
      const prevIndex = this.currentIndex === 0 ? this.slides.length - 1 : this.currentIndex - 1;
      this.goToSlide(prevIndex, 'prev');
    }

    waitForTransition(element) {
      return new Promise((resolve) => {
        const handleTransitionEnd = (e) => {
          if (e.target === element) {
            element.removeEventListener('transitionend', handleTransitionEnd);
            resolve();
          }
        };
        element.addEventListener('transitionend', handleTransitionEnd);
      });
    }

    handleTouchStart(e) {
      if (this.isAnimating) return;

      const touch = e.touches[0];
      this.touchStartX = touch.clientX;
      this.touchStartY = touch.clientY;
    }

    handleTouchMove(e) {
      if (this.isAnimating) return;

      const touch = e.touches[0];
      this.touchEndX = touch.clientX;
      this.touchEndY = touch.clientY;
    }

    handleTouchEnd(e) {
      if (this.isAnimating) return;

      const deltaX = this.touchEndX - this.touchStartX;
      const deltaY = this.touchEndY - this.touchStartY;
      const absDeltaX = Math.abs(deltaX);
      const absDeltaY = Math.abs(deltaY);

      // Only trigger swipe if horizontal movement is greater than vertical
      if (absDeltaX > absDeltaY && absDeltaX > this.minSwipeDistance) {
        if (deltaX > 0) {
          // Swipe right - go to previous slide
          this.previousSlide();
        } else {
          // Swipe left - go to next slide
          this.nextSlide();
        }
      }
    }

    // Utilities for media control
    pauseAllMediaExceptInSlide(slide) {
      const allowed = new Set(slide ? Array.from(slide.querySelectorAll('video-media, model-media')) : []);
      this.querySelectorAll('video-media[playing], model-media[playing]').forEach((el) => {
        if (!allowed.has(el)) {
          el.pause();
        }
      });
    }

    pauseNonActiveSlides() {
      this.slides.forEach((slide, index) => {
        if (index !== this.currentIndex) {
          slide.querySelectorAll('video-media[playing], model-media[playing]').forEach((element) => element.pause());
        }
      });
    }

    autoplayActiveSlideIfEligible() {
      const activeSlide = this.slides[this.currentIndex];
      if (!activeSlide) return;

      const mediaEls = activeSlide.querySelectorAll('video-media, model-media');
      mediaEls.forEach((element) => {
        if (!element.hasAttribute('autoplay')) return;
        if (element.hasAttribute('playing')) return;
        // If already loaded, try immediately; else wait for 'loaded' attribute
        if (element.hasAttribute('loaded')) {
          element.play();
        } else {
          const observer = new MutationObserver((mutations) => {
            for (const mutation of mutations) {
              if (mutation.type === 'attributes' && mutation.attributeName === 'loaded' && element.hasAttribute('loaded')) {
                observer.disconnect();
                element.play();
                break;
              }
            }
          });

          observer.observe(element, { attributes: true, attributeFilter: ['loaded'] });
        }
      });
    }
  }

  // Define the custom element
  customElements.define('media-gallery', MediaGalleryElement);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sticky-atc"] && !Shopify.designMode) return;
  try {
    class StickyAtc extends HTMLElement {
    connectedCallback() {
      if (this.dataset.init === 'true') return;
      this.dataset.init = 'true';

      const sectionId = this.dataset.sectionId;
      this.section =
        document.getElementById('shopify-section-' + sectionId) || document;

      this.bar = this;
      this.button = this.querySelector('[data-sticky-add]');
      this.buttonText = this.querySelector('[data-sticky-add-text]');
      this.priceEl = this.querySelector('[data-sticky-price]');
      this.mediaImg = this.querySelector('[data-sticky-media] img');
      this.defaultText = this.buttonText ? this.buttonText.textContent.trim() : 'Add to cart';

      this.realButton = this.findRealButton();
      if (!this.realButton) return; // No product form on page; nothing to delegate to.

      this.bindClick();
      this.observe();
      this.listenVariant();
    }

    findRealButton() {
      const selectors = [
        '[data-add-to-cart]',
        '.add-to-cart',
        'product-form form [type="submit"]',
        'form[action*="/cart/add"] [type="submit"]'
      ];
      for (const sel of selectors) {
        const el = this.section.querySelector(sel) || document.querySelector(sel);
        if (el) return el;
      }
      return null;
    }

    bindClick() {
      this.button.addEventListener('click', (e) => {
        e.preventDefault();
        if (this.button.disabled) return;
        // Delegate to the real button so the theme's own add + cart drawer fire.
        this.realButton.click();
      });
    }

    observe() {
      // Show the bar ONLY once the real Add to Cart button has scrolled up out
      // of view (customer scrolled past it). When the button is simply below the
      // fold on initial load, boundingClientRect.top is positive, so the bar
      // stays hidden until they actually scroll down past it.
      this.io = new IntersectionObserver((entries) => {
        const entry = entries[0];
        const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        this.bar.classList.toggle('is-visible', scrolledPast);
        this.bar.setAttribute('aria-hidden', scrolledPast ? 'false' : 'true');
      }, { threshold: 0 });
      this.io.observe(this.realButton);
    }

    listenVariant() {
      document.addEventListener('variant:change', (evt) => {
        const variant = evt.detail && evt.detail.variant;
        this.sync(variant);
      });
    }

    sync(variant) {
      // Availability + button label
      if (!variant) {
        this.setUnavailable('Unavailable');
        return;
      }
      if (!variant.available) {
        this.setUnavailable();
        return;
      }
      this.button.disabled = false;
      if (this.buttonText) this.buttonText.textContent = this.defaultText;

      // Price — copy the real, formatted price node for identical formatting
      // (handles sale styling + locale). Fall back to formatMoney from cents.
      const realPrice = this.section.querySelector('[data-product-price]');
      if (this.priceEl) {
        if (realPrice) {
          requestAnimationFrame(() => {
            this.priceEl.innerHTML = realPrice.innerHTML;
          });
        } else if (window.theme && theme.Currency) {
          this.priceEl.textContent = theme.Currency.formatMoney(
            variant.price,
            theme.moneyFormat || theme.settings.moneyFormat
          );
        }
      }

      // Variant image
      if (this.mediaImg && variant.featured_image && variant.featured_image.src) {
        this.mediaImg.src = variant.featured_image.src;
      }
    }

    setUnavailable(label) {
      this.button.disabled = true;
      if (this.buttonText) {
        this.buttonText.textContent = label || (window.theme && theme.strings && theme.strings.soldOut) || 'Sold out';
      }
    }
  }

  if (!customElements.get('sticky-atc')) {
    customElements.define('sticky-atc', StickyAtc);
  }
  } catch(e) { console.error(e); }
})();

})();
